import PropTypes from 'prop-types';

const errorsPropType = PropTypes.shape({
  favorites: PropTypes.object,
});

export default errorsPropType;
